export default function Comparator() {}